export enum InnovationType {
	MARADI = 'maradi',
	KOVETO = 'koveto',
	UJITO = 'ujito',
}
